import { connect } from 'react-redux';

import { getCurrencyType } from '../../../../browser/fast/fast_filters';
import { IAppState, Dispatch } from '../../../common/state';
import { ECurrencyType } from '../../../json_query';
import { setCurrencyType } from '../../state/currency_type';
import { CurrencyTypeSelect } from './index';

export const CurrencyTypeContainer = connect(
  (state: IAppState) => {
    return {
      currencyType: getCurrencyType(state),
    };
  },
  (dispatch: Dispatch) => ({
    onCurrencyTypeChanged: (currencyType: ECurrencyType) => {
      dispatch(setCurrencyType(currencyType));
    },
  }),
)(CurrencyTypeSelect);
